// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import myw from 'myWorld/base/core';
import './fieldEditor';

/**
 * Input for fields with an enumerator specified. <br/>
 * Displayed as either a dropdown (option element) or as buttons
 * @name EnumeratorFieldEditor
 * @constructor
 * @extends {FieldEditor}
 */
myw.EnumeratorFieldEditor = myw.FieldEditor.extend({
    tagName: 'select',
    className: 'text',
    options: {
        limitForExpanded: 6
    },
    events: _.extend({}, myw.FieldEditor.prototype.events, {
        'click li': 'selectItem'
    }),

    initialize(owner, feature, fieldDD, options) {
        myw.FieldEditor.prototype.initialize.call(this, owner, feature, fieldDD, options);
        const enumLength = fieldDD.enumValues.length;
        this.expandedMode =
            enumLength > this.options.limitForExpanded ? false : options.expandedMode;
        this.initUI();
        this.render();
    },

    initUI() {
        if (this.expandedMode) {
            const input = $('<ul>', { class: 'focused-select-menu', type: 'text' });
            this.setElement(input);
        } else if (this.el.tagName !== 'SELECT') {
            this.setElement($("<select class='text'></select>"));
        }
        this.$el.on('input', this._changed.bind(this));
    },

    render() {
        this.selectedValue = '';
        this.$el.empty();

        if (this.expandedMode) {
            this.renderExpanded();
            return;
        }

        // Create the list
        _.each(this.fieldDD.enumValues, enumValue => {
            const option = $('<option>')
                .val(enumValue.value)
                .text(enumValue.display_value);
            this.$el.append(option);
        });

        // add an empty option
        const disabledDefault = this.required ? 'disabled ' : '';
        const option = $(`<option value="" ${disabledDefault}selected></option>`);
        this.$el.append(option);
        this.$el.val(this.fieldValue);
    },

    /**
     * Find out if there is enough room for the expanded mode in the window
     * @return {boolean} True if there is enough room for the expanded mode else False
     */
    willExpandedModeFit() {
        const availableWidth = $(window).width() / 2;
        const list = $('<li>', { class: this.$el.prop('class') }).html(this.$el.html());
        list.appendTo('body');
        const fieldWidth = list.outerWidth();
        list.remove();
        return fieldWidth < availableWidth;
    },
    /**
     * Render a button-set and select the one with the fieldValue
     */
    renderExpanded() {
        _.each(this.fieldDD.enumValues, enumValue => {
            const listItem = $('<li>').text(enumValue.display_value);
            this.$el.append(listItem);

            if (enumValue.value == this.fieldValue) {
                listItem.addClass('selected');
            }
        });
        this.selectedValue = this.fieldValue;

        if (!this.willExpandedModeFit()) {
            this.expandedMode = false;
            this.initUI();
            this.render();
        }
    },

    /**
     * Styles and stores the selected list-element
     * @param  {object} ev Backbone event
     */
    selectItem(ev) {
        const currentlySelected = this.$('li.selected');
        currentlySelected.removeClass('selected'); // un-select the previously selected value

        if ($(ev.currentTarget)[0] === currentlySelected[0]) {
            this.selectedValue = ''; // delete the selected value
        } else {
            $(ev.currentTarget).addClass('selected');
            this.selectedValue = $(ev.currentTarget).text(); // store the selected value
        }
        this._changed({});
    },

    getValue() {
        if (this.expandedMode) {
            const enumValue = this.fieldDD.enumValues.find(
                enumValue => enumValue.display_value === this.selectedValue
            );
            return enumValue ? enumValue.value : '';
        } else {
            return this.$el.val();
        }
    },

    validate(value) {
        const missing = value === null || value === '';

        if (this.required && missing) {
            return this.msg('select_required');
        }
        return true;
    }
});

export default myw.EnumeratorFieldEditor;
